// WHAT: Shared types and context for global progress
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

/**
 * Interface for progress context value
 *
 * @public
 *
 */
// eslint-disable-next-line import/no-unused-modules -- Reason: This interface is exported for external use and type checking, even if not directly imported in other modules.
export interface ProgressContextType {
  /** Complete progress (sets to 100% then resets) */
  complete: () => void;
  /** End a sync operation */
  endSync: () => void;
  /** Whether any sync operation is currently active */
  isAnySyncActive: boolean;
  /** Progress percentage (0-100) */
  progress: number;
  /** Start a sync operation */
  startSync: () => void;
}

export const ProgressContext = createContext<ProgressContextType | undefined>(undefined);
